/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { FieldPath, UseFormReturn } from "react-hook-form";

import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { TableCell } from "@/components/ui/table";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { cn } from "@/lib/utils";

export const TableCellDateTimePicker = <T extends Record<string, unknown>>({
  disabled,
  fieldName,
  form,
  handleOnBlur,
  index,
  listName,
  rowId,
  showError,
}: {
  disabled?: boolean;
  fieldName: string;
  form: UseFormReturn<T>;
  handleOnBlur: (
    id: number,
    fieldName: string,
    updatedValue: string | null,
    type?: "date" | "number",
  ) => void;
  index: number;
  listName: string;
  rowId: number;
  showError?: (
    form: UseFormReturn<T>,
    fieldName: FieldPath<T> | string,
  ) => string;
}) => {
  const fieldNamePath = `${listName}.${index}.${fieldName}` as FieldPath<T>;

  return (
    <TableCell className={cn("p-1", showError?.(form, fieldNamePath))}>
      <FormField
        control={form.control}
        name={fieldNamePath}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Input
                {...field}
                id={`cell-${fieldName}-${index}`}
                className="w-full rounded-sm border-transparent bg-transparent hover:border-slate-300 focus:border-slate-300"
                disabled={disabled}
                type="datetime-local"
                onBlur={() => {
                  void form
                    .trigger(fieldNamePath, { shouldFocus: false })
                    .then((ok) => {
                      if (!ok) return;
                      handleOnBlur(
                        rowId,
                        fieldName,
                        field.value as string,
                        "date",
                      );
                      mixpanelUtils.trackInlineEdit(
                        fieldName,
                        getScreenFromPathname(location.pathname),
                      );
                    });
                }}
                value={field.value as string}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </TableCell>
  );
};
